// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__CcY9i","left":"StickyBox_left__ZadiU","right":"StickyBox_right__1sv_3"};